import * as React from 'react';

import { Button } from 'react-bootstrap';
import {Map, Pin, APIProvider, AdvancedMarker, } from '@vis.gl/react-google-maps';
import {View, rem} from './../libs/WebComponents';
import { Props } from '../types/types';
import pinpoint_bull from './../svgs/pinpoint-bull.svg';
import { GeoLocation } from '../App';

const GoogleMap = (props: Props)=>{
   const[geolocation, setGeolocation] = React.useState<GeoLocation>();

   React.useEffect(()=>{
      if (props.geolocation){
         setGeolocation({...props.geolocation});
      }
   },[props.geolocation]);

   const ToDestination = ()=>{
      window.open(`https://www.google.com/maps/dir/?api=1&destination=${geolocation?.lat},${geolocation?.lng}`);
   };

   return (
      <View style={{width: '95vw', height: '85vh', position: 'relative'}}>
         <APIProvider apiKey={globalThis.google_api_key} authReferrerPolicy={'origin'}>

               {geolocation?<Map mapId={'home_map'}
                  defaultCenter={geolocation}
                  defaultZoom={geolocation.zoom}
               >
                  <AdvancedMarker position={geolocation}>
                     <Pin><img src={pinpoint_bull} style={{width:rem(6)}} /></Pin>
                  </AdvancedMarker>
            </Map>:null}
            <Button className={'btn-success'} style={{position:'absolute',bottom:rem(1),zIndex:100,left:'calc(50% - 7rem)',transform:'scale(.7)', width:rem(14)}} onClick={props.closePopup}>Sluit</Button>
            <Button style={{position:'absolute',bottom:rem(4.5),zIndex:100,left:'calc(50% - 10rem)',width:rem(20), transform:'scale(.5)'}} onClick={ToDestination}>Toon route</Button>
         </APIProvider>
      </View>
   );


};

export default React.memo(GoogleMap);
